import React from 'react';

import BoxedIcon, { Props as BoxedIconProps } from '@/components/Icon/BoxedIcon';

export type Props = Omit<BoxedIconProps, 'type'>;

const CloseIcon = ({ className }: React.PropsWithChildren<Props>) => <BoxedIcon type="close" className={className} />;

export default CloseIcon;
